import type { GetApiV1ThreeLetterCodeClientAdminsPrefectures200 } from '@fukuri-admins/apis/client/gen/model';
import type { ShippingAddressEditFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ShippingAddressEditFormPresentation>;

type Args = {
  prefecturesData: GetApiV1ThreeLetterCodeClientAdminsPrefectures200;
};

type IConvertToPresentationProps = (args: Args) => Pick<PresentationProps, 'prefectureOptions'>;

/**
 * 都道府県一覧 API レスポンスを編集フォーム Presentation の選択肢に変換する
 *
 * - prefectures は code / name の両方を持つものだけを Select の選択肢（value = code）にする
 *   （EditUsageRequest の convertToPresentationProps と同じ扱い）
 * - 変換を伴わない値（isSaving・onCancel・onSubmit）は Container から Presentation に直接渡す
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ prefecturesData }) => ({
  prefectureOptions: prefecturesData.prefectures
    .filter(prefecture => prefecture.code != null && prefecture.name != null)
    .map(prefecture => ({ value: prefecture.code as string, label: prefecture.name as string })),
});
